export default __webpack_public_path__ + "static/media/Billie 9781408345184.355dad8f.jpg";